export type GetAccountConfigurationResponse = {
  transactionFee: {
    toFipayUser: number;
    toExternalUser: number;
    toWire: number;
    [key: string]: any;
  };
};

export const getAccountConfiguration =
  async (): Promise<GetAccountConfigurationResponse> => {
    return {
      transactionFee: { toFipayUser: 5, toExternalUser: 202, toWire: 304 },
    };
  };
